var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.stores.Deposits')))]),(
          _vm.$site.salesPayments_allow &&
          (_vm.$user.admin ||
            _vm.$user.role.sales_payments_add)
        )?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/storesDeposits/create?store_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.stores.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('storesDeposits.searchForAnStoresDepositsOperations'),"emptyTableText":_vm.$t('storesDeposits.thereAreNostoresDepositsOperations'),"filter":{store_id: _vm.$route.params.id},"withoutCard":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('storesDeposits.operation'),
          type: 'mainLink',
          sort: true,
        },
        {
          column: 'store_id',
          title: _vm.$t('storesDeposits.storeName'),
          type: 'link',
          to: 'store',
          sort: true,
          link: true,
        },
        {
          column: 'date',
          title: _vm.$t('storesDeposits.theDateOfTheOperation'),
          type: 'text',
          sort: true,
        },
        {
          column: 'description',
          title: _vm.$t('storesDeposits.description'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('storesDeposits.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin || _vm.$user.role.stores_deposits_edit,
            },
            { name: 'printStoresDeposit', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.stores_deposits_delete,
            },
          ],
        },
      ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }